module.exports = __webpack_public_path__ + "img/plb10.67563cbf.png";